export default __webpack_public_path__ + "static/media/ellipse_history_title.198a6cc4.svg";